import {Pipe, PipeTransform} from '@angular/core';
import {clFormatDuration} from '@castlabs/ui';
@Pipe({
    name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(start_date: string|Date|number, end_date?: string|Date): string {
    if (typeof start_date === 'number' && end_date === undefined) {
      // Treat as duration in seconds
      const start = new Date(0);
      const end = new Date(start_date * 1000);
      return clFormatDuration(start, end, true, false);
    }
    if (typeof start_date === 'string') {
      start_date = new Date(Date.parse(start_date));
    }
    if (typeof end_date === 'string') {
      end_date = new Date(Date.parse(end_date));
    }
    return clFormatDuration(start_date as Date, end_date as Date, true, false)
  }
}
